<template>
    <!-- 增加难度等级 -->
    <div v-if="difficulty || showSpace" class="difficultyLevel">
        <template v-if="difficulty">
            <span>难度：</span>
            <span
                v-for="(item) in level"
                :key="item"
            >
                <span class="greyStar" :class="{star: item <= difficulty}"></span>
            </span>
        </template>
    </div>
</template>

<script>
export default {
    name: 'DifficultyLevel',
    props: {
        card: {
            type: Object,
            default() {
                return {};
            }
        },
        // 是否空白展示，兼容课程卡片对齐问题
        showSpace: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            level: [1, 2, 3, 4, 5]
        };
    },
    computed: {
        difficulty() {
            return this.card.difficulty_level || this.card.difficultyLevel;
        }
    }
};

</script>
<style lang="less" scoped>
.difficultyLevel {
    margin: 8px 0 20px;
    height: 18px;
    font-size: 16px;
    color: #818A92;

    span {
        vertical-align: middle;
    }

    .greyStar {
        display: inline-block;
        margin: 0 4px 0;
        width: 20px;
        height: 20px;
        background: url(~assets/img/slogan/greyStar.png) no-repeat;

        &.star {
            background: url(~assets/img/slogan/glodStar.png) no-repeat;
        }
    }
}
</style>
